import React, { Component } from 'react'
import { Col } from 'react-bootstrap'

export class DialogConfirmacionContent extends Component {
  render () {
    const { message } = this.props

    return (
      <Col md={12}>
        <div style={{ textAlign: 'center', fontSize: '1.2rem' }}>
          {message}
        </div>
      </Col>
    )
  }
}
